module.exports = __webpack_public_path__ + "assets/1054233ae23399e2f10e147c68cf606f.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/timice/Desktop/ROC2/engine/public-src/spingames/panel/sounds/buttons/denoms/denom_500.mp3
 ** module id = 50
 ** module chunks = 0
 **/